import 'open-props/open-props.min.css'
import '../../../ui/assets/css/index.css'
import '../css/blocks.css'
import '../css/signup.css'

// Password input switch
const passwordButtons = document.querySelectorAll('[data-ident="password"] button')

function showPassword (e) {
  const button = e.currentTarget
  const parent = button.closest('.input')
  const input = parent.querySelector('input')
  const svgs = Array.from(button.querySelector('svg').children)

  input.type = input.type === 'password' ? 'text' : 'password'
  svgs.forEach(svg => {
    svg.style.display = svg.classList.contains(input.type) ? 'block' : 'none'
  })
}

document.addEventListener('DOMContentLoaded', () => {
  if (passwordButtons) {
    passwordButtons.forEach(button => {
      button.addEventListener('click', showPassword)
    })
  }
})

document.addEventListener('DOMContentLoaded', async () => {
  const flags = JSON.parse(document.body.dataset.flags)

  /**
   * @legacy
   * @prev core/templates/core/billing_popin.html
   */
  flags.askProof && await import('./payzen.js')
})
